import omit from 'lodash/omit'

// update legacy latlon param to mapbox hash
const handleLatlon = (to, from, next) => {
  // add fromRoute param to make available in setup()
  if (from?.name) {
    to.meta.fromRoute = from.name
  }

  // continue if no param
  if (!to.query.latlon) {
    next()
  }

  // convert to hash
  const [lat, lon, zoom] = to.query.latlon.split(',')
  const hash = `#${zoom}/${lat}/${lon}`

  next({ ...to, hash, query: omit(to.query, ['latlon']) })
}

export const paramHandler = (to, from, next) => {
  handleLatlon(to, from, next)
}
